<template>
    <el-popover
        placement="bottom"
        width="200"
        @show="showPopover"
        @hide="hidePopover"
        trigger="click">
        <el-button slot="reference" size="mini" type="primary" plain>+添加筛选</el-button>
        <div class="popover-wrap">
            <ul>
                <li class="mt4 mb4" v-if="options.length>0">
                    <el-checkbox v-model="isSelectAll" :indeterminate="isIndeterminate" @change="selectAll">全选</el-checkbox>
                </li>
                <li class="mt4 mb4" v-for="(item,index) in options" :key="index">
                    <el-checkbox v-model="item.checked" @change="itemCheckChange" :disabled="item.default_check">
                        {{item.label}}
                    </el-checkbox>
                </li>
            </ul>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: "FilterPopSelect",
        props:{
            list:Array,
            value:Array,
        },
        data(){
            return {
                options:[],
                isSelectAll:false,

            }
        },
        computed:{
            isIndeterminate(){
                let options = this.options||[];
                return options.some(item=>item.checked)&&options.some(item=>!item.checked);
            },
        },
        methods:{
            showPopover(){
                let checkedList = this.value||[];
                this.options = this.list && this.list.map(item=>{
                    return {
                        'checked': checkedList.includes(item.name),
                        'name': item.name,
                        'label': item.label,
                        'default_check': item.default_check ? item.default_check:false,
                    }
                });
                this.isSelectAll = checkedList.length>0&&(this.options.length==checkedList.length);
            },
            hidePopover(){
                let checkedList = this.options.filter(item=>item.checked).map(item=>item.name);
                this.$emit('change',checkedList);
            },
            itemCheckChange(value, index){
                this.isSelectAll = this.options.every(item=>item.checked);
            },
            selectAll(val){
                this.options.forEach(item=>{
                    if(item.default_check){
                        item.checked = true;
                    }else{
                        item.checked = val;
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .popover-wrap{
        max-height: 300px;
        overflow-y: auto;
    }
</style>
